// @flow
import PropTypes from 'prop-types'
import styled from 'styled-components'
import React from 'react'
import RadioButtonSquare from './RadioButtonSquare'

const RadioGroupWrapper = styled.div`
  display: flex;
  border-radius: ${p => p.theme.forms.borderRadius};
  overflow: hidden;
  label {
    user-select: none;
    cursor: pointer;
    font-weight: ${p => p.theme.button.fontWeight};
    text-transform: ${p => p.theme.button.textTransform};
    letter-spacing: ${p => p.theme.button.letterSpacing};
    font-size: ${p => p.theme.button.fontSize};
    padding: 0 10px 0px 10px;
    border: 0px !important;
    &:first-of-type {
      border-radius: ${p => p.theme.forms.borderRadius} 0px 0px
        ${p => p.theme.forms.borderRadius} !important;
      span {
        border-radius: ${p => p.theme.forms.borderRadius} 0px 0px
          ${p => p.theme.forms.borderRadius};
      }
    }
    &:last-of-type {
      border-radius: 0px ${p => p.theme.forms.borderRadius}
        ${p => p.theme.forms.borderRadius} 0px !important;
      span {
        border-radius: 0px ${p => p.theme.forms.borderRadius}
          ${p => p.theme.forms.borderRadius} 0px;
      }
    }
  }
`

const RadioGroup = ({
  name,
  options,
  type,
  onChange,
  value,
  disabled,
  ...rest
}) => (
  <RadioGroupWrapper type={type} {...rest}>
    {options.map(item => (
      <RadioButtonSquare
        disabled={disabled}
        key={item.value}
        name={name}
        value={item.value}
        label={item.label}
        checked={item.value === value}
        onChange={onChange}
        data-webid={item['data-webid']}
      />
    ))}
  </RadioGroupWrapper>
)

RadioGroup.defaultProps = {
  name: '',
  type: '',
  options: '',
  disabled: false,
}

RadioGroup.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape()),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}

export default RadioGroup
